import { render } from "./myPays.vue?vue&type=template&id=918ee2bc&scoped=true&ts=true"
import script from "./myPays.vue?vue&type=script&lang=ts"
export * from "./myPays.vue?vue&type=script&lang=ts"

import "./myPays.vue?vue&type=style&index=0&id=918ee2bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918ee2bc"]])

export default __exports__